export const DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP';
export const CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP';
export const DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP = 'DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP';
export const DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP = 'DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP';
export const DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP = 'DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP';
export const DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP';
export const CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP';
export const DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP = 'DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP';
export const SET_AGE_OPTIONS_FOR_DIVISONS = 'SET_AGE_OPTIONS_FOR_DIVISONS';
export const DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS = 'DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS';
export const DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS = 'DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS';
export const GET_VIRTUAL_EVENT_SCORING_METHODS = 'GET_VIRTUAL_EVENT_SCORING_METHODS';
export const GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS = 'GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS';
export const DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS = 'DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS';
export const GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT = 'GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT';
export const SET_AGE_VERIFICATION_EVENT_FOR_EVENT = 'SET_AGE_VERIFICATION_EVENT_FOR_EVENT';
export const GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT = 'GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT';
export const DELETE_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP = 'DELETE_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP';



// WEBPACK FOOTER //
// ./src/features/tournament/events/constants.js